var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 40,
    viewBox: "0 0 29 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1167 39.2986L1.38171 39.1354V7.04053L27.1167 7.20344V39.2986Z",
    fill: "#5BE0A6",
    stroke: "#8095AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76439 27.3728H5.5977C5.44408 27.3728 5.31958 27.2483 5.31958 27.095V22.1382C5.31958 20.834 6.37701 19.7769 7.68088 19.7769C8.98507 19.7769 10.0422 20.834 10.0422 22.1382V27.095C10.0422 27.2483 9.91769 27.3728 9.76439 27.3728Z",
    fill: "#8095AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9065 27.3728H11.7398C11.5865 27.3728 11.462 27.2483 11.462 27.095V22.1382C11.462 20.834 12.5192 19.7769 13.8233 19.7769C15.1272 19.7769 16.1846 20.834 16.1846 22.1382V27.095C16.1846 27.2483 16.0598 27.3728 15.9065 27.3728Z",
    fill: "#8095AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0489 27.3728H17.8822C17.7286 27.3728 17.6041 27.2483 17.6041 27.095V22.1382C17.6041 20.834 18.6616 19.7769 19.9654 19.7769C21.2696 19.7769 22.3267 20.834 22.3267 22.1382V27.095C22.3267 27.2483 22.2022 27.3728 22.0489 27.3728Z",
    fill: "#8095AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6982 39.0087H9.79993C9.63607 39.0087 9.50293 38.8756 9.50293 38.7114V32.4231C9.50293 31.029 10.633 29.8989 12.0268 29.8989H16.4713C17.8651 29.8989 18.9955 31.029 18.9955 32.4231V38.7114C18.9955 38.8756 18.8627 39.0087 18.6982 39.0087Z",
    fill: "#8095AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76439 18.3299H5.5977C5.44408 18.3299 5.31958 18.2054 5.31958 18.0521V13.0952C5.31958 11.7907 6.37701 10.7339 7.68088 10.7339C8.98507 10.7339 10.0422 11.7907 10.0422 13.0952V18.0521C10.0422 18.2054 9.91769 18.3299 9.76439 18.3299Z",
    fill: "#8095AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9065 18.3299H11.7398C11.5865 18.3299 11.462 18.2054 11.462 18.0521V13.0952C11.462 11.7907 12.5192 10.7339 13.8233 10.7339C15.1272 10.7339 16.1846 11.7907 16.1846 13.0952V18.0521C16.1846 18.2054 16.0598 18.3299 15.9065 18.3299Z",
    fill: "#8095AF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0489 18.3299H17.8822C17.7286 18.3299 17.6041 18.2054 17.6041 18.0521V13.0952C17.6041 11.7907 18.6616 10.7339 19.9654 10.7339C21.2696 10.7339 22.3267 11.7907 22.3267 13.0952V18.0521C22.3267 18.2054 22.2022 18.3299 22.0489 18.3299Z",
    fill: "#8095AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5158 5.45111L14.5991 0.0794516C14.345 -0.0264839 14.0625 -0.0264839 13.8084 0.0794516L0.891737 5.45111C0.475512 5.62426 0.201904 6.05056 0.201904 6.52551C0.201904 7.16304 0.6879 7.67928 1.28744 7.67928H27.1204C27.72 7.67928 28.206 7.16304 28.206 6.52551C28.206 6.05056 27.932 5.62426 27.5158 5.45111Z",
    fill: "#8095AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09033 27.9295H22.5178V26.8164H5.09033V27.9295Z",
    fill: "#8095AF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09033 18.8862H22.5178V17.7734H5.09033V18.8862Z",
    fill: "#8095AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.cfb1e752.svg";
export { ForwardRef as ReactComponent };